// Shared by Clerk's built-in fields and every app-owned verification code field.
export const authCodeGroupStyle = { gap: '0.5rem' } as const;

export const authCodeSlotStyle = {
  width: 'clamp(2rem, 7.5vw, 2.5rem)',
  height: 'clamp(2rem, 7.5vw, 2.5rem)',
  flexShrink: 0,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '0.375rem',
  fontSize: '1.25rem',
  fontWeight: 500,
  lineHeight: 1,
  color: '#2f2925',
  backgroundColor: '#ffffff',
} as const;
